import { render, staticRenderFns } from "./ComoManagedGifts.vue?vue&type=template&id=038af11e"
import script from "./ComoManagedGifts.vue?vue&type=script&lang=ts"
export * from "./ComoManagedGifts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports